import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <div className="bg-black border border-[#F97316]/30 rounded-2xl p-6 flex flex-col gap-4" data-id="element-268">
      <div className="flex items-center gap-3" data-id="element-269">
        <div className="w-12 h-12 rounded-full bg-[#F97316]/20 border border-[#F97316]/40 flex items-center justify-center text-[#F97316] font-black text-sm flex-shrink-0" data-id="element-270">
          {initials}
        </div>
        <div data-id="element-271">
          <div className="text-[#F97316] text-sm" data-id="element-272">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-273">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-274">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-275">"{quote}"</p>
    </div>;
}
const testimonials = [{
  initials: 'MR',
  stars: 5,
  quote: 'Compré un domingo a la noche. El lunes entré al gimnasio con el plan exacto de la clase. Los 24 clases del Tomo 1 son exactamente lo que necesitaba para mis principiantes. Las fichas de progreso cambiaron la percepción de mis alumnos sobre su propio avance. Nunca más improviso.',
  name: 'Marcos R.',
  location: 'Buenos Aires, Argentina',
  level: 'Entrenador de Gimnasio de Barrio'
}, {
  initials: 'JG',
  stars: 5,
  quote: 'El sistema de potencia del Tomo 3 con mis intermedios me cambió todo. El primer mes, tres alumnos que llevaban meses estancados mejoraron visiblemente. Las 5 combinaciones de KO las usan en cada sesión. El guanteo ahora tiene estructura y los alumnos lo piden.',
  name: 'Jorge G.',
  location: 'Rosario, Argentina',
  level: 'Instructor de Boxeo Recreativo'
}, {
  initials: 'SV',
  stars: 5,
  quote: 'El Bono 1 del Kit Clase Mixta es único en el mercado. Tengo principiantes y avanzados en el mismo turno y ahora cada uno trabaja en su nivel sin que yo tenga que duplicar la clase. Antes tardaba 1 hora en armar un entrenamiento. Ahora abro el PDF y en 5 minutos tengo todo.',
  name: 'Sofía V.',
  location: 'Córdoba, Argentina',
  level: 'Profesora de Educación Física'
}, {
  initials: 'FL',
  stars: 5,
  quote: 'El sistema de planilla del Bono 2 eliminó los alumnos que se iban sin avisar. Ahora detecto quién está en riesgo de abandono con 2 semanas de anticipación. El protocolo de retención recupera el 60% de los que iban a irse. Solo con eso se pagó todo.',
  name: 'Fernando L.',
  location: 'Tucumán, Argentina',
  level: 'Entrenador Particular y Club'
}, {
  initials: 'LP',
  stars: 5,
  quote: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando la planificación del Tomo 1 y el sistema de guanteo del Bono 5. Los alumnos ahora tienen objetivos claros y quieren venir a cumplirlos.',
  name: 'Laura P.',
  location: 'Mendoza, Argentina',
  level: 'Profesora de Boxeo Recreativo'
}, {
  initials: 'VT',
  stars: 5,
  quote: 'Los Scripts del Bono 4 me salvaron de situaciones incómodas con alumnos intensos en el guanteo. Ahora tengo la frase exacta para cada situación. El Protocolo 3C del guanteo cambió completamente el clima del gimnasio. Nadie escala, todos aprenden.',
  name: 'Valeria T.',
  location: 'Santa Fe, Argentina',
  level: 'Entrenadora de Club'
}, {
  initials: 'AR',
  stars: 5,
  quote: 'El Bono 3 de Boxeo Sin Ring me salvó el mes de agosto. Teníamos el espacio en refacción 2 semanas. Antes perdía esos ingresos. Con el Kit de Layouts y los 12 micro-circuitos di clases en el parque sin cancelar nada. Los alumnos agradecieron que no paré.',
  name: 'Ana R.',
  location: 'Salta, Argentina',
  level: 'Instructora en Gimnasio de Barrio'
}, {
  initials: 'CR',
  stars: 5,
  quote: 'El sistema funciona perfecto acá. El lenguaje es neutro y todo se adapta sin problemas. Los 6 eventos del año generaron una comunidad que antes no existía. Tres alumnos me trajeron a sus hermanos después de La Noche de los Guantes.',
  name: 'Carlos R.',
  location: 'Ciudad de México, México',
  level: 'Entrenador de Boxeo Fitness'
}, {
  initials: 'PM',
  stars: 5,
  quote: 'Compré desde Colombia y el acceso fue inmediato. El contenido está perfectamente adaptado para usarse en cualquier país. El Tomo 4 de defensa es el mejor material de boxeo recreativo que he encontrado en español. Lo recomiendo a todos los entrenadores de la zona.',
  name: 'Pablo M.',
  location: 'Bogotá, Colombia',
  level: 'Instructor de Boxeo y Fitness'
}, {
  initials: 'RM',
  stars: 5,
  quote: 'Desde Chile, el sistema funciona exactamente igual. Las planillas, los scripts y los eventos son completamente adaptables. El Método Gym Lleno me ayudó a subir el precio de mis clases un 40% sin perder ningún alumno. Fue la mejor inversión del año.',
  name: 'Rodrigo M.',
  location: 'Santiago, Chile',
  level: 'Profesor de Boxeo Recreativo'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-276">
      <div className="max-w-5xl mx-auto" data-id="element-277">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-278">
          💬 LO QUE DICEN LOS ENTRENADORES QUE YA LO USAN
        </h2>
        <p className="text-gray-400 text-center mb-10" data-id="element-279">
          +500 entrenadores de boxeo de todo el mundo hispanohablante ya tienen
          su MegaPack
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-280">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-281" />)}
        </div>
      </div>
    </section>;
}